const downloadMailingLabel = (labelData, fileName) => {
  var mailingLabel = "\ufeff" + labelData;
  var mailingLabelFile;
  var downloadLink;
  var done = false;
  mailingLabelFile = new Blob([mailingLabel], {
    type: "text/csv;charset=UTF-8",
  });
  downloadLink = document.createElement("a");
  downloadLink.download = fileName;
  downloadLink.href = window.URL.createObjectURL(mailingLabelFile);
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
  done = true;

  return done;
};

// Function to create label data string
const createMailingLabels = (layerName, fields, features, view) => {
  let fieldObject = {};
  let labelData = [];
  var done = false;

  const labelTemplate =
    "\n{OwnerNames}\n{SiteAddress}\n{SiteCityState} CA {SiteZip5}\n";

  for (var a = 0; a < fields.length; a++) {
    fieldObject[fields[a].name] = {
      name: fields[a].name,
    };
  }

  for (let i = 0; i < features.length; i++) {
    //console.log("MailingLabels View", view);
    let labelContent = labelTemplate;
    for (let key in features[i].attributes) {
      if (fieldObject.hasOwnProperty(key)) {
        labelContent = labelContent.replace(
          `{${fieldObject[key].name}}`,
          features[i].attributes[key]
        );
      }
    }
    labelData.push(labelContent);
  }
  done = downloadMailingLabel(labelData, "MailingLabel.txt");
  return done;
};

const exportToMailingLabels = (tableObject, view) => {
  var done = false;
  createMailingLabels(
    tableObject.layerName,
    tableObject.fields,
    tableObject.features,
    view
  );

  done = true;
  return done;
};

export default exportToMailingLabels;
